var exports = {
  "dN": "PersonaPickerSheet.module__sheetContainer___LUdCc0",
  "wL": "PersonaPickerSheet.module__searchHeader___LUdCc0",
  "RK": "PersonaPickerSheet.module__modeTabsWrapper___LUdCc0",
  "vs": "PersonaPickerSheet.module__scopeNote___LUdCc0",
  "fi": "PersonaPickerSheet.module__segmentedTabs___LUdCc0",
  "Mc": "PersonaPickerSheet.module__searchInputWrapper___LUdCc0",
  "qc": "PersonaPickerSheet.module__searchIcon___LUdCc0",
  "Rt": "PersonaPickerSheet.module__searchInput___LUdCc0",
  "l4": "PersonaPickerSheet.module__listScrollArea___LUdCc0",
  "Gf": "PersonaPickerSheet.module__sectionTitle___LUdCc0",
  "SL": "PersonaPickerSheet.module__recentShelf___LUdCc0",
  "sF": "PersonaPickerSheet.module__recentChip___LUdCc0",
  "kd": "PersonaPickerSheet.module__personaItem___LUdCc0",
  "vu": "PersonaPickerSheet.module__active___LUdCc0",
  "ht": "PersonaPickerSheet.module__personaDetails___LUdCc0",
  "vb": "PersonaPickerSheet.module__personaPrimaryRow___LUdCc0",
  "_M": "PersonaPickerSheet.module__personaName___LUdCc0",
  "BN": "PersonaPickerSheet.module__personaPronouns___LUdCc0",
  "kY": "PersonaPickerSheet.module__tagBadge___LUdCc0",
  "J": "PersonaPickerSheet.module__activeCheck___LUdCc0",
  "qr": "PersonaPickerSheet.module__footer___LUdCc0",
  "EN": "PersonaPickerSheet.module__settingsLink___LUdCc0",
  "W$": "PersonaPickerSheet.module__emptyNotice___LUdCc0",
};

module.exports = exports;
